import React from 'react';
import { usePublicData } from '../../context/PublicDataContext';
import { img, Eyebrow, Display, Reveal, PrimaryButton, GhostButton } from './components/ui';
import Seo from './components/Seo';

/* Craftsmanship = the existing process steps, told as an editorial timeline
 * that alternates image and text. Data: /website/public/process. */
export default function CraftsmanshipPage() {
  const { process, sections, siteName } = usePublicData();
  const intro = sections.craftsmanship || sections.process || {};

  return (
    <>
      <Seo title="Craftsmanship" description={`From sketch to dispatch — how ${siteName} builds furniture.`} siteName={siteName} />

      <section className="pt-36 pb-16">
        <div className="max-w-6xl mx-auto px-6 max-w-3xl">
          <Eyebrow>Craftsmanship</Eyebrow>
          <Display as="h1" className="text-4xl md:text-[56px] mt-4">
            {intro.title || 'From sketch to dispatch.'}
          </Display>
          <p className="text-[#4a3d32] mt-6 text-[16px] leading-relaxed">
            {intro.body ||
              'Every piece passes through a considered sequence — design, material selection, joinery, finishing and quality checks — before it earns our name. Here is how a piece comes together.'}
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-6">
          {process.length ? (
            <div className="flex flex-col">
              {process.map((step, i) => (
                <Reveal key={step.id} className={`grid md:grid-cols-2 gap-8 md:gap-14 items-center py-10 border-t border-[#241811]/12 ${i === process.length - 1 ? 'border-b' : ''}`}>
                  <div className={i % 2 ? 'md:order-2' : ''}>
                    <div className="overflow-hidden bg-[#ece0cd] aspect-[16/10]">
                      <img src={img(step.image_url)} alt={step.title} loading="lazy" className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <div className={i % 2 ? 'md:order-1' : ''}>
                    <div className="font-display text-5xl font-light text-[#b5622f] mb-4">{String(i + 1).padStart(2, '0')}</div>
                    <h2 className="font-display text-2xl md:text-3xl mb-3">{step.title}</h2>
                    <p className="text-[#4a3d32] text-[15px] leading-relaxed max-w-md">{step.description}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 text-[#4a3d32]">
              <p className="font-display text-2xl mb-2 text-[#241811]">Process coming soon</p>
              <p className="text-sm">Add process steps in the admin panel to tell your craftsmanship story here.</p>
            </div>
          )}

          <div className="mt-16 flex flex-wrap gap-4 justify-center">
            <PrimaryButton href="/#contact">Request a quote</PrimaryButton>
            <GhostButton to="/products">Explore the range</GhostButton>
          </div>
        </div>
      </section>
    </>
  );
}
